import { useDispatch } from "react-redux"
import { NavLink } from "react-router-dom";
import { Navbar, Container, Nav } from 'react-bootstrap';
import { SYSTEM_CONSTANTS } from "../types";
import '../styles/header.css';
import app_logo from "../assets/app_logo.png";

const HeaderLogin = () => {
    return (
        <div>
            <nav className="navbar navbar-dark px-4" style={{ color: 'white' }}>
                <div className="navbar-child-box">
                    <NavLink to="/" className={"navbar-brand"}>
                        <img src={app_logo} alt="Logo" style={{ maxHeight: '80px', maxWidth: '100px' }} />
                    </NavLink>
                    <div className="navbar-child-box">
                        <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
                            <li className="app-header-title">
                                <a className="title-link" href="/">
                                    <label>{SYSTEM_CONSTANTS.SYSTEM_NAME}</label>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default HeaderLogin